import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../images/circle-info-regular-full.svg'
import styles from './styles.module.css'

export default function PeopleName ({ localPeopleData, setLocalPeopleData }) {
  return (
    <section className={styles.keywordDescriptionSection}>
      <div className={styles.keywordDescriptionContainer}>
        <div className={styles.keywordDescriptionColumn}>
          <div className={styles.sectionTitleWithIcon}>
            <label className={styles.KeywordDescriptionLabel} htmlFor='name'>
              Name
            </label>

            <Tooltip
              title='Filter by the person’s name associated with the property.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '.MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Name help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <input
            type='text'
            id='name'
            name='name'
            placeholder='Name'
            autoComplete='off'
            className={styles.KeywordDescriptionInput}
            value={localPeopleData?.name || ''}
            onChange={e =>
              setLocalPeopleData({
                ...localPeopleData,
                name: e.target.value
              })
            }
          />
        </div>
      </div>
    </section>
  )
}
